import template from './attendance_report_per_employee_help.html'
import * as Utils from '../../../lib/savanna_utils.js'

class AttendanceEmployeeReportHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
}

class AttendanceEmployeeReportHelpPage
{
	constructor(bindings)
	{
		this.viewModel = new AttendanceEmployeeReportHelpViewModel(this);
		this.bindings = bindings;
	}

	async init()
	{
		Utils.refresh_data_visible_roles()
	}
}

// Register the dialog
export default {
	name: 'AttendanceEmployeeReportHelp',
	dialog_class: AttendanceEmployeeReportHelpPage,
	template: template,
	template_filename: 'translation/dialogs/attendance_report_per_employee_help',
	provider: 'ps'
}